import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { history } from "src/services/history";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { PATHNAMES } from "src/constants/routes";
import { IBlog } from "src/@types/blog";

export const BLOG_SLICE_NAME = "blog";
export const ITEMS_PER_PAGE = 10;

interface Params {
  id: string;
}

export const getBlogCurrentPostAsync = createAsyncThunk(
  `${BLOG_SLICE_NAME}/fetchBlogCurrentPost`,
  async ({ id }: Params, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IBlog>(`/posts/${id}/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      history.push(PATHNAMES.HOME, { replace: true });

      NotificationService.error(
        errorText || errorResponsesTrns.gettingCurentBlogPost
      );

      return rejectWithValue(errorText);
    }
  }
);
